import { render } from "./FieldConfig.vue?vue&type=template&id=229a1edf&scoped=true"
import script from "./FieldConfig.vue?vue&type=script&lang=js"
export * from "./FieldConfig.vue?vue&type=script&lang=js"

import "./FieldConfig.vue?vue&type=style&index=0&id=229a1edf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229a1edf"]])

export default __exports__